"use strict";

angular.module("vendor")
.component("catalogDashboard", {
    templateUrl: require("./catalog-dashboard.component.html"),
    css: [require("./catalog-dashboard.useable.css")],
    controller: function($rootScope, $scope, $state, CatalogDashboardService) {
        $scope.pagination = {};

        this.goToCatalogEdit = function(catalogID) {
            $state.go("catalogEdit", {"id": catalogID});
        };

        this.fetch = function() {
            CatalogDashboardService.query($scope.pagination.current_page).$promise.then(function(data) {
                $scope.pagination = data.pagination;
                $scope.incompleteCatalog = data.results;
            });

        };

        var unregister = $scope.$on("currentNumbersUpdated", function(event, currentNumbers) {
            unregister();
            $scope.catalogCount = currentNumbers.Catalogs;
        });

        if ($rootScope.CurrentNumbers) {
            $scope.catalogCount = $rootScope.CurrentNumbers.Catalogs;
        }

        this.fetch();
    },
    controllerAs: "ctrl"
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-dashboard/catalog-dashboard.component.js
// module id = 934
// module chunks = 0